export default __webpack_public_path__ + "static/HLP-7d241c51c128a54cf271fcdb0c15c449.jpg";